var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.cardIds),function(cardId,index){return _c('PageCards',{key:index,attrs:{"cardId":cardId}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }